/* tslint:disable */

declare var Object: any;
export interface SFClaimReportInterface {
  "id"?: number;
}

export class SFClaimReport implements SFClaimReportInterface {
  "id": number;
  constructor(data?: SFClaimReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFClaimReport`.
   */
  public static getModelName() {
    return "SFClaimReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFClaimReport for dynamic purposes.
  **/
  public static factory(data: SFClaimReportInterface): SFClaimReport{
    return new SFClaimReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFClaimReport',
      plural: 'SFClaimReports',
      path: 'SFClaimReports',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFClaimReport.ts